module.exports = __webpack_public_path__ + "img/1f47f.6c75f53.svg";